import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "./store";
import { openapi } from "../openapi";

// Selector to fetch the cached version of whoami using RTK Query
export const selectRtkWhoami = createSelector(
  [(state: IRootState) => state],
  (state) => openapi.endpoints.getWhoami.select()(state).data?.user || null
);
